import React from "react";
import LicensesDetailsTable from "./LicensesDetailsTable";
import { Button, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import moment from "moment";
import { saveAs } from "file-saver";

const LicensesDetails = (props) => {
  if (!props.showLicenseDetails) {
    return null;
  }
  let rows = [];
  let columns = [];
  let columnBands = [];
  let dataForYearExcel;
  let title;

  let schoolsWithSelectedLicense = props.schools.filter(function (school) {
    return school.programLicenses.some(
      (license) => license.name === props.selectedLicenseDetail[1]
    );
  });

  const color = (text, status) => {
    const colors = { expired: "text-danger", added: "text-success" };
    let color = colors[status];
    return <span className={color}>{text}</span>;
  };

  const getDataForActive = () => {
    title = props.intl.formatMessage({ id: "ActiveLicenseTableTitle" });
    var fiscalYear = moment();
    if (moment(fiscalYear).month() > 5) {
      fiscalYear.start = moment().month(6).startOf("month");
    } else {
      fiscalYear.start = moment().subtract(1, "year").month(6).startOf("month");
    }

    let nbrMonthsThisFiscalYear = Math.ceil(
      moment().diff(moment(fiscalYear.start), "months", true)
    );

    var interim = fiscalYear.start.clone();
    var monthsThisFiscalYear = [];
    for (let i = 0; i < nbrMonthsThisFiscalYear; i++) {
      monthsThisFiscalYear.push(interim.format("YYYY-MM"));
      interim.add(1, "month");
    }

    monthsThisFiscalYear = monthsThisFiscalYear.reverse();

    let addedLicenses = [];
    let expiredLicenses = [];
    let schoolsWithExpiredLicense = schoolsWithSelectedLicense.filter(
      (school) => {
        return school.programLicenses.some(
          (license) =>
            license.hasExpired &&
            license.name === props.selectedLicenseDetail[1]
        );
      }
    );
    schoolsWithExpiredLicense.forEach((schoolWithExpired) => {
      let licenseExpired = schoolWithExpired.programLicenses.filter(
        (license) => {
          return license.name === props.selectedLicenseDetail[1];
        }
      );
      expiredLicenses.push(licenseExpired);
    });

    monthsThisFiscalYear.forEach((month) => {
      let expiredLicenseThisMonth = expiredLicenses.filter(
        (lic) => moment(lic[0].validTo).month() === moment(month).month()
      );
      schoolsWithSelectedLicense.forEach((school) => {
        let schoolWithNewLicense = school.programLicenses.filter((lic) => {
          return (
            lic.name === props.selectedLicenseDetail[1] &&
            moment(month).month() === moment(lic.addedDate).month() &&
            moment(month).year() === moment(lic.addedDate).year()
          );
        });
        if (schoolWithNewLicense.length > 0)
          addedLicenses.push(schoolWithNewLicense);
      });
      let monthToAdd = {
        id: month,
        sortOrder: moment(month).month(),
        parentId: null,
        title: moment(month).format("MMMM"),
        expiredLicences: color(expiredLicenseThisMonth.length, "expired"),
        newLicences: color(addedLicenses.length, "added"),
      };
      dataForYearExcel +=
        "<tr><td style=font-weight:bold;>" +
        moment(month).format("MMMM") +
        "</td><td style=background-color:'#FFC7CE'>" +
        expiredLicenseThisMonth.length +
        "</td><td style=background-color:'#C6EFCE'>" +
        addedLicenses.length +
        "</td></tr>";
      let expiredMonth = {
        parentId: month,
        id: month + "expired",
        title: color("Utgångna licenser", "expired"),
        expiredLicences: color(expiredLicenseThisMonth.length, "expired"),
      };
      let addedMonth = {
        parentId: month,
        id: month + "added",
        title: color("Tillagda licenser", "added"),
        newLicences: color(addedLicenses.length, "added"),
      };
      expiredLicenseThisMonth.forEach((expired) => {
        let schoolWithExpiredLicense = schoolsWithSelectedLicense.filter(
          (school) => school.id === expired[0].customerId
        );

        let exp = {
          id: schoolWithExpiredLicense[0].fortKnoxCustomerNumber + month,
          name: color(schoolWithExpiredLicense[0].name, "expired"),
          customerNumber: color(
            schoolWithExpiredLicense[0].fortKnoxCustomerNumber,
            "expired"
          ),
          address: color(schoolWithExpiredLicense[0].adress.street, "expired"),
          postalNumber: color(
            schoolWithExpiredLicense[0].adress.zipCode,
            "expired"
          ),
          city: color(schoolWithExpiredLicense[0].adress.city, "expired"),
          parentId: month + "expired",
        };
        if (exp) {
          rows.push(exp);
          dataForYearExcel +=
            "<tr><td></td><td></td><td></td><td align='right' style=background-color:'#FFC7CE'>" +
            schoolWithExpiredLicense[0].fortKnoxCustomerNumber +
            "</td><td align='right' style=background-color:'#FFC7CE'>" +
            schoolWithExpiredLicense[0].name +
            "</td><td align='right' style=background-color:'#FFC7CE'>" +
            schoolWithExpiredLicense[0].adress.street +
            "</td><td align='right' style=background-color:'#FFC7CE'>" +
            schoolWithExpiredLicense[0].adress.zipCode +
            "</td><td align='right' style=background-color:'#FFC7CE'>" +
            schoolWithExpiredLicense[0].adress.city +
            "</td></tr>";
        }
      });

      addedLicenses.forEach((added) => {
        let schoolWithNewLicense = schoolsWithSelectedLicense.filter(
          (school) => school.id === added[0].customerId
        );

        let add = {
          id: schoolWithNewLicense[0].fortKnoxCustomerNumber + month,
          name: color(schoolWithNewLicense[0].name, "added"),
          customerNumber: color(
            schoolWithNewLicense[0].fortKnoxCustomerNumber,
            "added"
          ),
          address: color(schoolWithNewLicense[0].adress.street, "added"),
          postalNumber: color(schoolWithNewLicense[0].adress.zipCode, "added"),
          city: color(schoolWithNewLicense[0].adress.city, "added"),
          parentId: month + "added",
        };
        if (add) {
          rows.push(add);
          dataForYearExcel +=
            "<tr><td></td><td></td><td></td><td align='left' style=background-color:'#C6EFCE'>" +
            schoolWithNewLicense[0].fortKnoxCustomerNumber +
            "</td><td align='left' style=background-color:'#C6EFCE'>" +
            schoolWithNewLicense[0].name +
            "</td><td align='left' style=background-color:'#C6EFCE'>" +
            schoolWithNewLicense[0].adress.street +
            "</td><td align='left' style=background-color:'#C6EFCE'>" +
            schoolWithNewLicense[0].adress.zipCode +
            "</td><td align='left' style=background-color:'#C6EFCE'>" +
            schoolWithNewLicense[0].adress.city +
            "</td></tr>";
        }
      });
      rows.push(addedMonth);
      rows.push(monthToAdd);
      rows.push(expiredMonth);
    });

    columns = [
      { name: "title", title: <FormattedMessage id="Month" /> },
      { name: "newLicences", title: <FormattedMessage id="AddedLicenses" /> },
      {
        name: "expiredLicences",
        title: <FormattedMessage id="ExpiredLicenses" />,
      },
      {
        name: "customerNumber",
        title: <FormattedMessage id="FortnoxNumber" />,
      },
      { name: "name", title: <FormattedMessage id="Name" /> },
      { name: "address", title: <FormattedMessage id="Address" /> },
      { name: "postalNumber", title: <FormattedMessage id="ZipCode" /> },
      { name: "city", title: <FormattedMessage id="City" /> },
    ];
    columnBands = [
      {
        title: "Antal",
        children: [
          { columnName: "newLicences" },
          { columnName: "expiredLicences" },
        ],
      },
      {
        title: "Skolor",
        children: [
          { columnName: "customerNumber" },
          { columnName: "name" },
          { columnName: "address" },
          { columnName: "postalNumber" },
          { columnName: "city" },
        ],
      },
    ];
  };

  const getDataForExpiring = () => {
    title = props.intl.formatMessage({ id: "ExpiringLicenseTableTitle" });
    let schoolsWithExpiringLicenses = schoolsWithSelectedLicense.filter(
      (school) => {
        return school.programLicenses.some(
          (license) =>
            license.hasExpireWarning &&
            license.name === props.selectedLicenseDetail[1]
        );
      }
    );
    schoolsWithExpiringLicenses.forEach((schoolWithExpiring) => {
      let licenseExpiring = schoolWithExpiring.programLicenses.filter(
        (license) => {
          return license.name === props.selectedLicenseDetail[1];
        }
      );
      let schoolToAdd = {
        id: schoolWithExpiring.id,
        parentId: null,
        customerNumber: schoolWithExpiring.fortKnoxCustomerNumber,
        name: schoolWithExpiring.name,
        address: schoolWithExpiring.adress.street,
        postalNumber: schoolWithExpiring.adress.zipCode,
        city: schoolWithExpiring.adress.city,
        licenseExpiringAt: moment(licenseExpiring[0].validTo).format(
          "YYYY-MM-DD"
        ),
      };
      rows.push(schoolToAdd);
    });
    rows.sort((a, b) =>
      a.licenseExpiringAt > b.licenseExpiringAt
        ? 1
        : b.licenseExpiringAt > a.licenseExpiringAt
        ? -1
        : 0
    );
    columns = [
      {
        name: "customerNumber",
        title: <FormattedMessage id="FortnoxNumber" />,
      },
      { name: "name", title: <FormattedMessage id="Name" /> },
      { name: "address", title: <FormattedMessage id="Address" /> },
      { name: "postalNumber", title: <FormattedMessage id="ZipCode" /> },
      { name: "city", title: <FormattedMessage id="City" /> },
      {
        name: "licenseExpiringAt",
        title: <FormattedMessage id="LicenseExpiringAt" />,
      },
    ];
  };

  const getDataForExpired = () => {
    title = props.intl.formatMessage({ id: "ExpiredLicenseTableTitle" });
    let schoolsWithExpiredLicense = schoolsWithSelectedLicense.filter(
      (school) => {
        return school.programLicenses.some(
          (license) =>
            license.hasExpired &&
            license.name === props.selectedLicenseDetail[1]
        );
      }
    );
    schoolsWithExpiredLicense.forEach((schoolWithExpired) => {
      let licenseExpired = schoolWithExpired.programLicenses.filter(
        (license) => {
          return license.name === props.selectedLicenseDetail[1];
        }
      );
      let schoolToAdd = {
        id: schoolWithExpired.id,
        parentId: null,
        customerNumber: schoolWithExpired.fortKnoxCustomerNumber,
        name: schoolWithExpired.name,
        address: schoolWithExpired.adress.street,
        postalNumber: schoolWithExpired.adress.zipCode,
        city: schoolWithExpired.adress.city,
        licenseExpiredAt: moment(licenseExpired[0].validTo).format(
          "YYYY-MM-DD"
        ),
      };
      rows.push(schoolToAdd);
    });
    rows.sort((a, b) =>
      a.licenseExpiredAt < b.licenseExpiredAt
        ? 1
        : b.licenseExpiredAt < a.licenseExpiredAt
        ? -1
        : 0
    );
    columns = [
      {
        name: "customerNumber",
        title: <FormattedMessage id="FortnoxNumber" />,
      },
      { name: "name", title: <FormattedMessage id="Name" /> },
      { name: "address", title: <FormattedMessage id="Address" /> },
      { name: "postalNumber", title: <FormattedMessage id="ZipCode" /> },
      { name: "city", title: <FormattedMessage id="City" /> },
      {
        name: "licenseExpiredAt",
        title: <FormattedMessage id="LicenseExpiredAt" />,
      },
    ];
  };

  if (props.selectedLicenseDetail[0] === "Active") {
    getDataForActive();
  } else if (props.selectedLicenseDetail[0] === "Expired") {
    getDataForExpired();
  } else if (props.selectedLicenseDetail[0] === "Expiring") {
    getDataForExpiring();
  }

  const fnExcelReport = function () {
    let fileName = "";
    var tab_text = "<table>";
    if (props.selectedLicenseDetail[0] === "Active") {
      fileName = "LicenserFörÅret" + props.selectedLicenseDetail[1] + ".xls";
      tab_text =
        tab_text +
        "<tr><th align='left'>" +
        props.intl.formatMessage({ id: "Month" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "ExpiredLicenses" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "AddedLicenses" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "FortnoxNumber" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "Name" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "Address" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "ZipCode" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "City" }) +
        "</th></tr>";
      tab_text = tab_text + dataForYearExcel;
    } else if (props.selectedLicenseDetail[0] === "Expired") {
      fileName = "UtgågnaLicenser" + props.selectedLicenseDetail[1] + ".xls";
      tab_text =
        tab_text +
        "<tr><th align='left'>" +
        props.intl.formatMessage({ id: "FortnoxNumber" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "Name" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "Address" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "ZipCode" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "City" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "LicenseExpiredAt" }) +
        "</th></tr>";
      rows.map((row) => {
        return (tab_text +=
          "<tr>" +
          "<td align='left'>" +
          row.customerNumber +
          "</td><td align='left'>" +
          row.name +
          "</td><td align='left'>" +
          row.address +
          "</td><td align='left'>" +
          row.postalNumber +
          "</td><td align='left'>" +
          row.city +
          "</td><td align='left'>" +
          row.licenseExpiredAt +
          "</td> </tr>");
      });
    } else if (props.selectedLicenseDetail[0] === "Expiring") {
      fileName = "UtgåendeLicenser" + props.selectedLicenseDetail[1] + ".xls";
      tab_text =
        tab_text +
        "<tr><th align='left'>" +
        props.intl.formatMessage({ id: "FortnoxNumber" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "Name" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "Address" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "ZipCode" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "City" }) +
        "</th><th align='left'>" +
        props.intl.formatMessage({ id: "LicenseExpiringAt" }) +
        "</th></tr>";
      rows.map((row) => {
        return (tab_text +=
          "<tr>" +
          "<td align='left'>" +
          row.customerNumber +
          "</td><td align='left'>" +
          row.name +
          "</td><td align='left'>" +
          row.address +
          "</td><td align='left'>" +
          row.postalNumber +
          "</td><td align='left'>" +
          row.city +
          "</td><td align='left'>" +
          row.licenseExpiringAt +
          "</td> </tr>");
      });
    }
    tab_text = tab_text + "</table>";
    var data = new Blob(["\ufeff", tab_text], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      encoding: "utf-8",
    });
    saveAs(data, fileName);
  };

  //TODO Set correct title!
  return (
    <div className="container-fluid admin-container">
      <Row className="mb-2">
        <Col>
          <Button color="primary" outline onClick={() => props.closeDetails()}>
            <FontAwesomeIcon icon="times" />
          </Button>
          <Button
            className="ms-2"
            color="primary"
            outline
            onClick={fnExcelReport}
          >
            <FormattedMessage id="ExportToXls" />
          </Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="h4">
            {title}
            {props.selectedLicenseDetail[1]}
          </p>
        </Col>
      </Row>
      <LicensesDetailsTable
        rows={rows}
        cols={columns}
        columnBands={columnBands}
      />
    </div>
  );
};

LicensesDetails.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(LicensesDetails);
